import type { FunctionComponent } from 'react'
import { useEffect } from 'react'
import SelectPartnerWarehousePage from '../../legacy/components/SelectPartnerWarehouse/SelectPartnerWarehousePage'
import { DashRoute } from '../../legacy/dash-components/dash-route/DashRoute'
import { DashRedirect } from '../../legacy/dash-components/dash-redirect/DashRedirect'
import { DashSwitch } from '../../legacy/dash-components/dash-switch/DashSwitch'
import { CurrentAccountProvider } from '../../utils/current-account/CurrentAccountProvider'
import { AiAgentProvider } from '../../utils/contexts/ai/AiAgentProvider'
import { ImpersonationStatusBanner } from '../../gin-and-tonic/containers/impersonation-status-banner/ImpersonationStatusBanner'
import { PartnerWriteAccessErrorNotifier } from '../../gin-and-tonic/common/partner-write-access-error/PartnerWriteAccessErrorNotifier'
import { PrivacyComplianceProvider } from '../../components/privacy-compliance'
import { GlobalCookieDetection } from '../../utils/browser/GlobalCookieDetection'
import { NotLoggedInRedirect } from './components/NotLoggedInRedirect'
import { PartnerScopedSection } from './partner-scoped/PartnerScopedSection'

export const LoggedInRoutes: FunctionComponent = () => (
  <CurrentAccountProvider>
    <NotLoggedInRedirect>
      <GlobalCookieDetection />
      <AiAgentProvider>
        <PartnerWriteAccessErrorNotifier />
        <ImpersonationStatusBanner />
        <PrivacyComplianceProvider />
        <DashSwitch>
          <DashRoute route="scope" component={SelectPartnerWarehousePage} />
          <DashRoute route="partner-scoped" component={PartnerScopedSection} />
          {/* If the user is on the URL_BASE route, we send them to the scope selector */}
          <DashRedirect exact fromRoute="base" toRoute="scope" />
        </DashSwitch>
      </AiAgentProvider>
    </NotLoggedInRedirect>
  </CurrentAccountProvider>
)
